import React, { useEffect } from 'react';
import ProcedureActionImage from './ProcedureActionImage';
import { getService } from '@Shared.Angular/flowingly.hooks/useService';
import ReactDOM from 'react-dom';
import IProcedureActionDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureActionDetail';
import OverlayType from '@Shared.Angular/@types/core/contracts/queryModel/procedure/overlayType';

type Props = {
  action: IProcedureActionDetail;
  headerIndex: number;
  onClose: () => void;
  onNavigateBackwards?: () => void;
  onNavigateForwards?: () => void;
};

const ProcedureActionImageView = ({
  action,
  headerIndex,
  onClose,
  onNavigateBackwards,
  onNavigateForwards
}: Props) => {
  const [imageDataUrl, setImageDataUrl] = React.useState('');

  useEffect(() => {
    setImageDataUrl('');
    if (!action) return;

    const fileId = action.modifiedFileId || action.originalFileId;
    let objectUrl: string;

    if (fileId) {
      getService('fileService')
        .getFileById(fileId)
        .then((result) => {
          objectUrl = URL.createObjectURL(result.data);
          setImageDataUrl(objectUrl);
        });
    } else {
      setImageDataUrl('');
    }
  }, [action]);

  useEffect(() => {
    return () => {
      if (imageDataUrl) URL.revokeObjectURL(imageDataUrl);
    };
  }, [imageDataUrl]);

  const highlightOverlays =
    action?.overlays?.filter((o) => o.type === OverlayType.Highlight) || [];

  return (
    action &&
    ReactDOM.createPortal(
      <div className="procedure-image-view">
        <div
          className={
            'navigator navigate-previous' +
            (onNavigateBackwards ? '' : ' hidden')
          }
          title="Previous"
          onClick={onNavigateBackwards}
        >
          <i className="fa-light fa-chevron-left"></i>
        </div>
        <div className="procedure-image" onClick={onClose}>
          <div className="header">
            <div className="procedure-field">
              <div className="field-index">
                {headerIndex < 10 ? '0' : ''}
                {headerIndex}
              </div>
              <div className="field-title">{action.title}</div>
            </div>
            <div
              className="fa-light fa-close"
              title="Close"
              onClick={onClose}
              data-testid="procedure-image-view-close"
            ></div>
          </div>
          {imageDataUrl && (
            <ProcedureActionImage
              key={action.id}
              imageDataUrl={imageDataUrl}
              overlays={highlightOverlays}
              enableWheelZoom={true}
            />
          )}
        </div>
        <div
          className={
            'navigator navigate-next' + (onNavigateForwards ? '' : ' hidden')
          }
          title="Next"
          onClick={onNavigateForwards}
        >
          <i className="fa-light fa-chevron-right"></i>
        </div>
      </div>,
      document.body
    )
  );
};

export default ProcedureActionImageView;
